/**
 * Work 페이지 — 실제 진행한 프로젝트·전시 목록.
 * 목록 클릭 시 상세 내용을 모달(WorkDetailModal)로 표시합니다.
 * media: 모달 갤러리용 미디어 목록 — type: 'video' | 'image'
 * info: 모달 개요 표(전시 정보) — label/value 쌍
 * detailParagraphs: 모달 본문 문단
 */
export const WORK_ITEMS = [
  {
    id: 'isekai-entrance',
    kind: 'project',
    tag: '전시',
    title: '《이세계 입장!》 — Aura AR 전시',
    date: '2026.06',
    image: '/image/work/isekai-01.jpg',
    excerpt:
      '성수 프로젝트 스페이스 큐에서 김세현·박시호 작가와 함께, 회화 위에 또 하나의 세계를 겹쳐낸 Aura AR 전시입니다.',
    media: [
      { type: 'video', src: '/image/work/isekai-teaser.mp4', label: '현장 영상' },
      { type: 'image', src: '/image/work/isekai-01.jpg', label: '전시 전경 1' },
      { type: 'image', src: '/image/work/isekai-02.jpg', label: '전시 전경 2' },
      { type: 'image', src: '/image/work/isekai-03.jpg', label: '전시 전경 3' },
    ],
    info: [
      { label: '전시명', value: '이세계 입장!' },
      { label: '장소', value: '프로젝트 스페이스 큐 (서울 성수)' },
      { label: '기간', value: '2026. 06. 06 — 06. 20' },
      { label: '참여 작가', value: '김세현, 박시호' },
      { label: '기술', value: 'Aura WebAR' },
    ],
    detailParagraphs: [
      '2026년 6월 6일부터 20일까지, 성수 프로젝트 스페이스 큐에서 전시 《이세계 입장!》을 선보였습니다. 김세현·박시호 두 작가와 함께한 이번 전시는 Aura 플랫폼을 활용한 AR 전시로, 애니메이션적 상상력으로 그려진 회화들이 갤러리의 흰 벽을 채웠습니다.',
      '관람객이 스마트폰 카메라를 작품에 비추는 순간, 멈춰 있던 화면 속 인물들이 깨어나며 현실 공간 위로 또 하나의 세계가 겹쳐집니다. 별도의 앱 설치 없이 브라우저만으로 작동하는 Aura WebAR 덕분에, 누구나 QR 스캔 한 번으로 곧바로 ‘이세계’에 입장할 수 있었습니다.',
      '전시 기간 동안에는 Aura 운영 화면에서 AR 콘텐츠를 실시간으로 관리하며 현장 반응에 맞춰 경험을 다듬었습니다. 평면 회화와 AR이 만나 전시 제목 그대로의 감각 — ‘입장’의 순간을 만들어낸 사례입니다.',
    ],
  },
];
